import type {SVGProps} from "react";

export const TotalFundsIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}
    >
        <g clipPath="url(#total-funds-clip)">
            <path
                d="M8.77441 1.4541V14.9958"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.1598 3.48535H7.08171C6.4532 3.48535 5.85043 3.73503 5.40601 4.17945C4.96159 4.62387 4.71191 5.22664 4.71191 5.85514C4.71191 6.48365 4.96159 7.08642 5.40601 7.53084C5.85043 7.97526 6.4532 8.22494 7.08171 8.22494H10.4671C11.0956 8.22494 11.6984 8.47461 12.1428 8.91903C12.5872 9.36345 12.8369 9.96622 12.8369 10.5947C12.8369 11.2232 12.5872 11.826 12.1428 12.2704C11.6984 12.7148 11.0956 12.9645 10.4671 12.9645H4.71191"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="total-funds-clip">
                <rect width="16.25" height="16.25" fill="white" transform="translate(0.649414 0.0999756)" />
            </clipPath>
        </defs>
    </svg>
);
